import type { LoginRequest, LoginResponse, User, UserSelfUpdate } from '@comic/shared'
import { api } from './client'

export const authApi = {
  login: (body: LoginRequest) =>
    api<LoginResponse>('/api/auth/login', { method: 'POST', body: JSON.stringify(body) }),
  logout: () =>
    api<void>('/api/auth/logout', { method: 'POST' }),
  me: () =>
    api<User>('/api/auth/me'),
  patchMe: (body: UserSelfUpdate) =>
    api<User>('/api/auth/me', { method: 'PATCH', body: JSON.stringify(body) }),
}
